var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquatorialGuinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 39.9999C31.0461 39.9999 40.0004 31.0456 40.0004 19.9999C40.0004 8.95418 31.0461 -0.00012207 20.0004 -0.00012207C8.95467 -0.00012207 0.000366211 8.95418 0.000366211 19.9999C0.000366211 31.0456 8.95467 39.9999 20.0004 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1739 13.0435H38.7559C35.9302 5.4275 28.5992 0 20 0C14.477 0 9.47758 2.23898 5.85852 5.85851L12.1739 13.0435Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1739 26.9564H38.7559C35.9302 34.5724 28.5992 39.9999 20 39.9999C14.477 39.9999 9.47758 37.761 5.85852 34.1414L12.1739 26.9564Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85785 5.85779C-1.95262 13.6683 -1.95262 26.3316 5.85785 34.1422C9.08543 30.9146 12.1896 27.8104 20 20L5.85785 5.85779Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4783 16.5217V20.8695C23.4783 23.532 26.9566 24.3478 26.9566 24.3478C26.9566 24.3478 30.4348 23.532 30.4348 20.8695V16.5217H23.4783Z",
    fill: "#DEDDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.087 20.0869H27.8262V22.6086H26.087V20.0869Z",
    fill: "#786145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6957 19.1304C28.6957 18.1698 27.9171 17.3912 26.9566 17.3912C25.996 17.3912 25.2174 18.1698 25.2174 19.1304C24.7372 19.1304 24.3479 19.5197 24.3479 19.9999C24.3479 20.4801 24.7372 20.8694 25.2174 20.8694H28.6957C29.1759 20.8694 29.5652 20.4801 29.5652 19.9999C29.5652 19.5197 29.176 19.1304 28.6957 19.1304V19.1304Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquatorialGuinea);
export default __webpack_public_path__ + "static/media/equatorial_guinea.a9e984898dbfc43f093091045789fd46.svg";
export { ForwardRef as ReactComponent };